export const rolesThatHideEmail = ["oem"];

export const shouldShowEmail = (role: string) => {
    return !rolesThatHideEmail.includes(role);
};
